import { usePatch } from '../../query/usePatch'

export function useUpdateProfile() {
  const patch = usePatch(`${'/users/profile'}`)
  return patch
}
